import React from "react";
import { Link, Typography } from "@mui/material";

export default function Footer({ publicFooter }: { publicFooter?: boolean }) {
  const termsOfUseUrl = "https://3aware.ai/terms-of-service/";
  const privacyPolicyUrl = "https://3aware.ai/privacy-policy/";
  const startYear = 2022;

  return (
    <div
      className={`${publicFooter ? `public-shared-footer` : `shared-footer`}`}
    >
      <Link
        href={termsOfUseUrl}
        target="_blank"
        rel="noreferrer"
        variant="body1"
      >
        Terms of Use
      </Link>{" "}
      <Link
        href={privacyPolicyUrl}
        target="_blank"
        rel="noreferrer"
        variant="body1"
      >
        Privacy Policy
      </Link>{" "}
      <Typography variant="body1">
        &copy;{`${startYear}-${new Date().getFullYear()} 3Aware, Inc.`}
      </Typography>
    </div>
  );
}
